module.exports = __webpack_public_path__ + "static/img/LUKE-CANDY.b4ea200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LUKE-CANDY.jpg
// module id = l25a
// module chunks = 0